var _circle, _circle2, _circle3, _circle4, _path, _mask, _path2, _circle5, _circle6, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertReorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 67,
    viewBox: "0 0 78 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 60,
    r: 6,
    fill: "white",
    stroke: "#EC1B2C",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 59,
    r: 5,
    fill: "#EDEDED"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 60,
    r: 6,
    fill: "white",
    stroke: "#EC1B2C",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 59,
    r: 5,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 22.5H6.5V34.5H12",
    stroke: "#EDEDED",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-1_1980_18984",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 19,
    width: 13,
    height: 18,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1,
    y: 19,
    width: 13,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 35V33H8V21H4C3.44772 21 3 21.4477 3 22C3 22.5523 3.44772 23 4 23H6V35H12Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 33H14V31H12V33ZM12 35V37H14V35H12ZM6 35H4C4 36.1046 4.89543 37 6 37V35ZM6 23H8C8 21.8954 7.10457 21 6 21V23ZM8 21H10C10 19.8954 9.10457 19 8 19V21ZM8 33H6C6 34.1046 6.89543 35 8 35V33ZM12 33H10V35H12H14V33H12ZM12 35V33H6V35V37H12V35ZM6 35H8V23H6H4V35H6ZM6 23V21H4V23V25H6V23ZM4 21V23H8V21V19H4V21ZM8 21H6V33H8H10V21H8ZM8 33V35H12V33V31H8V33ZM3 22H5C5 22.5523 4.55228 23 4 23V21V19C2.34315 19 1 20.3431 1 22H3ZM4 23V21C4.55228 21 5 21.4477 5 22H3H1C1 23.6569 2.34315 25 4 25V23Z",
    fill: "#EC1B2C",
    mask: "url(#path-6-outside-1_1980_18984)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 5,
    r: 4,
    stroke: "#EC1B2C",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 7,
    r: 3,
    fill: "#EDEDED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 5C54.8366 5 62 12.1634 62 21V22H21V21C21 12.1634 28.1634 5 37 5H46Z",
    fill: "white",
    stroke: "#F46E20",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59 22H22C22 14.8203 27.8203 9 35 9H40.5H46C53.1797 9 59 14.8203 59 22Z",
    fill: "#EDEDED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 27C17 25.8954 17.8954 25 19 25H62C63.1046 25 64 25.8954 64 27V29H17V27Z",
    fill: "#EDEDED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64 22C65.6569 22 67 23.3431 67 25V30H16V25C16 23.3431 17.3431 22 19 22H64Z",
    stroke: "#F46E20",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68 29C69.1046 29 70 29.8954 70 31V58C70 58.9772 69.6228 60.1978 68.8311 61.1875C68.013 62.21 66.7369 63 65 63C63.2631 63 61.987 62.21 61.1689 61.1875C61.11 61.1138 61.0544 61.038 61 60.9619C60.9456 61.038 60.89 61.1138 60.8311 61.1875C60.013 62.21 58.7369 63 57 63C55.2631 63 53.987 62.21 53.1689 61.1875C53.11 61.1138 53.0544 61.038 53 60.9619C52.9456 61.038 52.89 61.1138 52.8311 61.1875C52.013 62.21 50.7369 63 49 63C47.2631 63 45.987 62.21 45.1689 61.1875C45.0856 61.0834 45.0078 60.9759 44.9336 60.8672C44.8455 60.9863 44.7538 61.1028 44.6572 61.2148C43.8248 62.1811 42.5689 63 41 63C39.4311 63 38.1752 62.1811 37.3428 61.2148C37.2461 61.1026 37.1536 60.9865 37.0654 60.8672C36.9913 60.9757 36.9143 61.0835 36.8311 61.1875C36.013 62.21 34.7369 63 33 63C31.2631 63 29.987 62.21 29.1689 61.1875C29.1225 61.1295 29.0778 61.0703 29.0342 61.0107C28.9962 61.0646 28.9585 61.1191 28.918 61.1719C28.1092 62.2232 26.8195 63 25 63C23.2631 63 21.987 62.21 21.1689 61.1875C21.1354 61.1455 21.1034 61.1023 21.0713 61.0596C21.049 61.0915 21.0282 61.1247 21.0049 61.1562C20.2068 62.237 18.9009 63 17 63C15.0741 63 13.7737 62.1748 12.9883 61.084C12.2398 60.0442 12 58.8266 12 58V31C12 29.8954 12.8954 29 14 29H68Z",
    fill: "white",
    stroke: "#138059",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13 32H16H66C66.5523 32 67 32.4477 67 33V58C67 59.5 67.5 62 64 62C62.5 62 61 59.5 61 58C61 59.5 59.8 62 57 62C54.2 62 53 59.5 53 58C53 59.5 51.8 62 49 62C46.2 62 45 59.5 45 58C45 59.5 43.4 62 41 62C38.6 62 37 59.5 37 58C37 59.5 35.8 62 33 62C30.2 62 29 59.5 29 58C29 59.5 28 62 25 62C22.2 62 21 59.5 21 58C21 59.5 20.2 62 17 62C13.8 62 13 59.3333 13 58V32Z",
    fill: "#EDEDED"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45 61V55",
    stroke: "#138059",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21 61V55",
    stroke: "#138059",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M53 61V55",
    stroke: "#138059",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29 61V55",
    stroke: "#138059",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61V55",
    stroke: "#138059",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37 61V55",
    stroke: "#138059",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1 66H76.5",
    stroke: "#EC1B2C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertReorder);
export default __webpack_public_path__ + "static/media/alert_reorder.9b0e11751cb74c608d78de6a8a70a9fa.svg";
export { ForwardRef as ReactComponent };